import { render, staticRenderFns } from "./Bind.vue?vue&type=template&id=93510498&scoped=true&"
import script from "./Bind.vue?vue&type=script&lang=js&"
export * from "./Bind.vue?vue&type=script&lang=js&"
import style0 from "./Bind.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Bind.vue?vue&type=style&index=1&id=93510498&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93510498",
  null
  
)

export default component.exports